export const RECEIVE_LOCALE = 'RECEIVE_LOCALE';
export const REQUEST_LOCALE = 'REQUEST_LOCALE';
